var errorCodes = {
  1: 'denied',
  2: 'unavailable',
  3: 'timeout'
};
var sandbox = Oskari.getSandbox();
var log = Oskari.log('Oskari.mapframework.module.LocationModule');
// let _pathJson = null;
var _locationCoords = [];
var _locationWatch = null;
function _addCoord(pos) {
  _locationCoords.push([pos.lon, pos.lat]);
}
;
function notifyError(cb, code) {
  var error = errorCodes[code] || errorCodes[2];
  if (typeof cb === 'function') {
    cb(error);
  }
  var evt = Oskari.eventBuilder('UserLocationEvent');
  // notify event without position to signal failure
  sandbox.notifyAll(evt(null, null, null, error));
}
;
function notifyLonLat(cb, lonlat, accuracy) {
  if (typeof cb === 'function') {
    cb(lonlat.lon, lonlat.lat, accuracy);
  }
  var evt = Oskari.eventBuilder('UserLocationEvent');
  sandbox.notifyAll(evt(lonlat.lon, lonlat.lat, accuracy));
}
;
function notifyPosition(cb, pos) {
  if (typeof cb === 'function') {
    cb(pos);
  }
  var evt = Oskari.eventBuilder('UserLocationEvent');
  sandbox.notifyAll(evt(pos.lon, pos.lat, pos.accuracy));
}
;

// TODO: push pos to pathJson coords.
// Now geojson is generated from coords array on update if it's added to map
// Also geojson could be added to event
/*
function _updatePath (pos) {
    _addCoord(pos);
    if (_pathJson) {

    }
};
*/
/**
 * Tries to get the user location. Signals with an UserLocationEvent and callback with lon and lat params
 * when successfully got the location or without params as error indicator.
 * @param  {Function} successCb function that is called with lon, lat and accuracy as params on happy case
 * @param  {Function} errorCB function that is called with error as params on failure
 * @param  {Object}   options  options for navigator.geolocation.getCurrentPosition()
 */
export function getUserLocation(successCb, errorCB, options) {
  // normalize opts with defaults
  var mapmodule = sandbox.findRegisteredModuleInstance('MainMapModule');
  var opts = options || {};
  var navigatorOpts = {
    maximumAge: 0,
    timeout: 6000,
    enableHighAccuracy: false
  };
  // override defaults with given options
  Object.keys(navigatorOpts).forEach(function (key) {
    if (opts.hasOwnProperty(key)) {
      navigatorOpts[key] = opts[key];
    }
  });
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var _position$coords = position.coords,
        longitude = _position$coords.longitude,
        latitude = _position$coords.latitude,
        accuracy = _position$coords.accuracy;
      // transform coordinates from browser projection to current
      var lonlat = mapmodule.transformCoordinates({
        lon: longitude,
        lat: latitude
      }, 'EPSG:4326');
      if (mapmodule.isValidLonLat(lonlat.lon, lonlat.lat)) {
        notifyLonLat(successCb, lonlat, accuracy);
      } else {
        notifyError(errorCB);
      }
    }, function (errors) {
      log.warn('Error getting user location', errors);
      notifyError(errorCB, errors.code);
    }, navigatorOpts);
  } else {
    // browser doesn't support
    notifyError(errorCB);
  }
}
;
export function watchUserLocation(successCb, errorCB, options) {
  var mapmodule = sandbox.findRegisteredModuleInstance('MainMapModule');
  var opts = options || {};
  var prevTime;
  // default values
  var navigatorOpts = {
    maximumAge: 5000,
    timeout: 10000,
    enableHighAccuracy: true
  };
  // override defaults with given options
  Object.keys(navigatorOpts).forEach(function (key) {
    if (opts.hasOwnProperty(key)) {
      navigatorOpts[key] = opts[key];
    }
  });
  if (navigator.geolocation) {
    _locationWatch = navigator.geolocation.watchPosition(function (position) {
      log.debug(position);
      var timestamp = position.timestamp,
        coords = position.coords;
      if (prevTime === timestamp) {
        // some browsers sends first previous position and then changed position
        // TODO: is this only location emulator feature, test how this works with mobile phones
        return;
      }
      prevTime = timestamp;
      // transform coordinates from browser projection to current
      var pos = mapmodule.transformCoordinates({
        lon: coords.longitude,
        lat: coords.latitude
      }, 'EPSG:4326');
      if (!mapmodule.isValidLonLat(pos.lon, pos.lat)) {
        notifyError(errorCB);
        return;
      }
      pos.accuracy = coords.accuracy;
      _addCoord(pos);
      notifyPosition(successCb, pos);
    }, function (errors) {
      log.warn('Error getting user location', errors);
      notifyError(errorCB, errors.code);
    }, navigatorOpts);
  } else {
    // browser doesn't support
    notifyError(errorCB);
  }
}
;
export function getLocationCoords() {
  return _locationCoords;
}
;
export function stopUserLocationWatch() {
  if (navigator.geolocation && _locationWatch !== null) {
    navigator.geolocation.clearWatch(_locationWatch);
    _locationWatch = null;
  }
}
;
export function clearLocationCoords() {
  _locationCoords = [];
}
;
// TODO: check if add geometry to map is better to do here instead of handlers